<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Signout
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Admin</a>
        </li>
      </ul>
    </div>
    <b-card>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto">
          SignOut Info
        </div>
        <span class="float-right">Request from {{model.created_at | sdate}}</span>
      </div>
      <hr>
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_company">
            Partner
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <h5>
            <a style="cursor:pointer;color:skyblue;" id="ph_company" v-if="model.partner" @click="$router.push({ name : 'partner', params : { id : model.partner.id } })">
              {{model.partner.username}}
            </a>
          </h5>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_groupname">
            Group
          </label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <h5>
            <a style="cursor:pointer;color:skyblue;" id="ph_groupname" v-if="model.group" @click="$router.push({ name : 'group', params : { id : model.group.id } })">
              {{model.group.groupname}}
            </a>
          </h5>
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_credit">
            Credit
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <b-form-input type="text" v-if="model.group && lock" :value="model.group.credit" plaintext></b-form-input>
          <!-- <b-form-input v-if="model.group" class="bg-light" type="text" id="ph_credit" :plantext="true"  v-model="model.group.credit" :disabled="lock"></b-form-input> -->
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_service">
            Service
          </label>
        </div>
        <div class="col-xl-4 col-md-12 align-self-center">
          <b-badge  v-if="model.group && lock" :variant="model.group.service == 'Basic' ? 'info' : 'success'">{{model.group.service}}</b-badge>
          <!-- <b-form-input v-if="model.group" class="bg-light" type="text" id="ph_service" :plantext="true"  v-model="model.group.service" :disabled="lock"></b-form-input> -->
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" abel-for="ph_use" v-b-tooltip.hover title="Compelate signout process">
            Sigout Approve
          </label>
        </div>
        <div class="col-xl-4 col-md-12 align-self-center">
          <b-badge :variant="model.is_approve ? 'success' : 'secondary'">{{ model.is_approve ? 'Complete' : 'Wating'}}</b-badge>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_use" v-b-tooltip.hover title="Recovery setting for continue using">
            Termination defense
          </label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_recovery" :disabled="lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
          <span v-if="model.is_recovery" class="pl-3 mt-1">({{model.recovery_at | datetime}})</span>
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.is_approve">
          <label class="col-form-label" lfor="ph_company" v-b-tooltip.hover title="Recent Using Date.">
            Recent Using Date
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.is_approve">
          <b-form-input type="text" id="ph_company" v-model="model.prev_bill_start_at" :plaintext="lock"></b-form-input>
            ~
          <b-form-input type="text" id="ph_company" v-model="model.prev_bill_end_at" :plaintext="lock"></b-form-input>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.is_approve">
          <label class="col-form-label" for="ph_description">
            Description
          </label>
        </div>
        <div class="col-xl-4 col-md-12" v-if="model.is_approve">
          <b-form-input type="text" v-if="lock" :value="model.description" plaintext></b-form-input>
          <!-- <b-form-input class="bg-light" type="text" id="ph_description" :disabled="model.is_del" v-model="model.description"></b-form-input> -->
        </div>
      </div>
      <div class=" mb-2 mt-5">
        <b-button :disabled="model.is_del" size="sm" variant="success" @click="confirm_continue = true"> Termination defense(Continue) </b-button>
        <b-button :disabled="model.is_del" size="sm" variant="danger" @click="confirm_end = true"> End of service </b-button>
        <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
      </div>
    </b-card>
    <b-modal title="Service using continue"  class="modal-warning" v-model="confirm_continue" @ok="service_continue" ok-variant="warning">
      Are you sure continue using service ?
      again start charge from today, all can use
    </b-modal>
    <b-modal title="End of service"  class="modal-danger" v-model="confirm_end" @ok="service_end" ok-variant="danger">
      Are you sure End of serevice ?
      later can delete data, can not recovery it
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>